import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';

const { confirm } = Modal;

const Prompt = ({
  content,
  okText,
  cancelText,
  onOkClick,
  onCancelClick,
  title,
  width
}) => (
  <div>
    {(
      confirm({
        title: title || 'Save Changes?',
        content: content || (
          <div>
            <p>
              You have made changes to this form which has not been saved.
            </p>
            <p>
              Do you wish to save these changes?
            </p>
          </div>
        ),
        okText: okText || 'Yes - Save Changes',
        cancelText: cancelText || 'No - Discard Changes',
        onOk() {
          onOkClick();
        },
        onCancel() {
          onCancelClick();
        },
        width: width || '600px'
      })
    )}
  </div>
);
Prompt.propTypes = {
  content: PropTypes.object.isRequired,
  okText: PropTypes.string.isRequired,
  cancelText: PropTypes.string.isRequired,
  onOkClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired
};

export default Prompt;
